import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=60bf650c&scoped=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=60bf650c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf650c",
  null
  
)

export default component.exports